module.exports = __webpack_public_path__ + "img/NSW.feec2cf8.png";